module.exports = __webpack_public_path__ + "img/bg.91a8068a.webp";